import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translation files
import enCommon from './locales/en/common.json'
import enDashboard from './locales/en/dashboard.json'
import enHelp from './locales/en/help.json'
import ptCommon from './locales/pt/common.json'
import ptDashboard from './locales/pt/dashboard.json'
import ptHelp from './locales/pt/help.json'

// Translation resources
const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    help: enHelp
  },
  pt: {
    common: ptCommon,
    dashboard: ptDashboard,
    help: ptHelp
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt', // default language
    fallbackLng: 'pt',

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'help'],

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Development options
    debug: process.env.NODE_ENV === 'development',

    // Key separator (use '.' for nested keys)
    keySeparator: '.',

    // Namespace separator
    nsSeparator: ':'
  })

export default i18n
